/**
 * @param {ArrayBuffer} buffer
 * @param {string} name
 * @returns {FileList}
 */
const toFileList = (buffer, name) => {
  console.log('toFileList called', { buffer, name });
  if (!name) {
    name = 'Untitled';
  }

  const file = new File([buffer], name);
  const dataTransfer = new DataTransfer();
  dataTransfer.items.add(file);
  console.log('toFileList result', dataTransfer.files);
  return dataTransfer.files;
};

const importFromParent = ({
  origin,
  onStartImporting,
  onFinishImporting,
  onCancelImporting
}) => {
  console.log('importFromParent called with origin', origin);

  if (!origin.startsWith('http:') && !origin.startsWith('https:')) {
    console.warn('Import ignored: invalid origin', origin);
    return;
  }

  const opener = window.opener || window.parent;
  console.log('importFromParent opener', opener);
  if (!opener || opener === window) {
    console.warn('Import ignored: cannot find parent window or opener');
    return;
  }

  const postToParent = (data) => {
    try {
      console.log('postToParent sending', data, 'to', origin);
      opener.postMessage({ p4: data }, origin);
    } catch (e) {
      console.warn('Cannot post message', e);
    }
  };

  let hasStarted = false;
  let hasFinishedOrCancelled = false;

  const onMessage = (e) => {
    console.log('PACKAGER MESSAGE raw', e);
    const data = e.data && e.data.p4;
    console.log('PACKAGER P4', data);

    if (!data) return;

    if (!hasStarted) {
      if (data.type === 'start-import') {
        console.log('PACKAGER start-import');
        hasStarted = true;
        onStartImporting();
      }
    } else if (!hasFinishedOrCancelled) {
      if (data.type === 'finish-import') {
        console.log('PACKAGER finish-import', data);
        cleanup();
        onFinishImporting(toFileList(data.data, data.name));
      } else if (data.type === 'cancel-import') {
        console.log('PACKAGER cancel-import', data);
        cleanup();
        onCancelImporting();
      } else {
        console.log('PACKAGER unknown type after start', data.type);
      }
    }
  };
  window.addEventListener('message', onMessage);
  console.log('importFromParent: message listener attached');

  const cleanup = () => {
    hasFinishedOrCancelled = true;
    console.log('importFromParent cleanup: removing listener');
    window.removeEventListener('message', onMessage);
  };

  postToParent({ type: 'ready-for-import' });
};

const importFromAPI = async ({
  onStartImporting,
  onFinishImporting,
  onCancelImporting
}) => {
  console.log('importFromAPI called');
  try {
    onStartImporting();
    const { data, name } = await GlobalPackagerImporter();
    console.log('importFromAPI got data', { data, name });
    onFinishImporting(toFileList(data, name));
  } catch (e) {
    console.log('importFromAPI error', e);
    onCancelImporting();
  }
};
const importProject = ({
  onStartImporting,
  onFinishImporting,
  onCancelImporting
}) => {
  console.log('importProject called, location.search =', location.search);
  console.log('GlobalPackagerImporter type =', typeof GlobalPackagerImporter);

  if (typeof GlobalPackagerImporter === 'function') {
    console.log('Using importFromAPI');
    importFromAPI({
      onStartImporting,
      onFinishImporting,
      onCancelImporting
    });
    return;
  }

  const searchParams = new URLSearchParams(location.search);
  console.log('has import_from?', searchParams.has('import_from'),
              'value:', searchParams.get('import_from'));

  if (searchParams.has('import_from')) {
    importFromParent({
      origin: searchParams.get('import_from'),
      onStartImporting,
      onFinishImporting,
      onCancelImporting
    });
  } else {
    console.log('importProject: no import_from param, not importing from parent');
  }
};

export default importProject;
